export const TARGET_MEDIA_WIDTH = 1224;
